// extracted by mini-css-extract-plugin
module.exports = {"queue-modal":"QueueModal_queue-modal__2fL1N","queue-detail":"QueueModal_queue-detail__21WZv","close-btn":"QueueModal_close-btn__oaMQt"};